import { render, staticRenderFns } from "./I18n.vue?vue&type=template&id=57ef89f4"
import script from "./I18n.vue?vue&type=script&lang=js"
export * from "./I18n.vue?vue&type=script&lang=js"
import style0 from "./I18n.vue?vue&type=style&index=0&id=57ef89f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports